import { Checkbox, DateTimeInput, Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { DateTimeDataFormat } from 'Lib/Format';
import { useSelector } from 'react-redux';
let AsLinearShrinkageDryingSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const OvenDried = useSelector(createWorksheetSelector!(`Preparation.FinalDryingMethod`)) === 'Oven drying';

  return (
    <>
      <ListFieldSection heading="Initial Drying - Room Temperature">
        <Field
          input={<DateTimeInput />}
          name="Preparation.DryingStartedAtDateTime"
          dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
        />
        <Field
          input={<DateTimeInput />}
          name="Preparation.DryingCompletedAtDateTime"
          dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
        />
        <Field input={<TextOutput />} name="Preparation.InitialDryingTime" />
        <Field input={<Checkbox />} name="Preparation.ColourChangeObserved" />
      </ListFieldSection>
      <ListFieldSection heading="Final Drying">
        <Field
          input={<RadioGroup />}
          name="Preparation.FinalDryingMethod"
          simpleValue
          options={['Oven drying', 'Air drying'].map((e) => ({ label: e, value: e }))}
        />
        <Field input={<Checkbox />} name="Preparation.ShrinkageCeased" />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="oven"
          name="Preparation.Oven"
          visible={OvenDried}
        />
        <Field input={<NumericInput />} name="Preparation.OvenTemperature" visible={OvenDried} />
      </ListFieldSection>
    </>
  );
};

AsLinearShrinkageDryingSection = withInjectedProps(AsLinearShrinkageDryingSection);

export default AsLinearShrinkageDryingSection;
